
import ArrowRight from '@/components/PZIcons/ArrowRight'
export default {
	props: {
		tabTitle: {
			type: String
		},
		jumpUrl: {
			type: String
		}
	},
	components: {
		ArrowRight
	},
	methods: {
		handleClick() {
			if (this.jumpUrl) {
				this.$router.push(this.jumpUrl)
			}
		}
	}
}
